import dayjs from 'dayjs';
import axios from '../config'
import Cookies from 'js-cookie';


const getCountry = async (lst) => {
    let data = { 'data': lst }

    const rs = await axios.post('/uget_country',
        JSON.stringify(data),
        { headers: { 'Content-Type': 'application/json', 'token': Cookies.get('token') } })

    try {
        if (rs.data) {
            let country = rs.data.country
            let countryCode = rs.data.countryCode
            return { 'country': country, 'countryCode': countryCode }

        }
    }
    catch (error) {
        console.log(error)
    }
}


const LOGIN = async (data) => {

    try {
        const rs = await axios.post('/ulogin', { 'username': data.username, 'password': data.password })

        console.log(rs.data)
        if (rs.data && rs.data.token) {
            return rs.data.token 
        }

    } catch (error) {
        console.log(error)
        return null

    }

}


const getShipements = async ()=>{

    const rs = await axios.get('/ushipments', {headers:{'token': Cookies.get('token')}})

    try {
        if(rs.data){
            return rs.data
        }
    } catch (error) {
        console.log(error)
        return []
    }

}

const getShipement = async (id)=>{

    const rs = await axios.get(`/ushipments/${id}`, {headers:{'token': Cookies.get('token')}})

    try {
        if(rs.data){
            return rs.data
        }
    } catch (error) {
        console.log(error)
        return {}
    }

}

const creatShipementInServer = async (orderID)=>{
    const rs = await axios.put(`/ushipments/new`, {'orderID': orderID}, {headers:{'token': Cookies.get('token')}})
    try {
        if(rs.data){
            return rs.data
        }
    } catch (error) {
        console.log(error)
    }
}


const deleteShipementInServer = async (id)=>{
    const l = 135
    let ms = prompt(`Введите цифру ${l}`);
    
    if (l === +ms) {
        const rs = await axios.delete(`/ushipments/${id}`, {'id':id}, {headers:{'token': Cookies.get('token')}})
        if (rs.data){
            console.log(rs.data)
            return rs.data
        }
       
    }

}

const updateShipmentInServer = async (shipment) =>{

    const newShipment = {
        'id': shipment.id,
        'order_id': shipment.order_id,
        'date': dayjs(shipment.date).format(),
        "step_id": shipment.step_id,
        'transport': shipment.transport,
        'tracking_id': shipment.tracking_id,
        'tracking_link': shipment.tracking_link,
        'isDelivery': shipment.isDelivery,
        'last_update_date': shipment.last_update_date,
        'last_update_status': shipment.last_update_status,
        'last_update_comment': shipment.last_update_comment
    }

    const rs = await axios.post(`/ushipments/${shipment.id}`, JSON.stringify(newShipment), { headers: { 'Content-Type': 'application/json', 'token':Cookies.get('token') } })
    try {
        if(rs.data){
            return rs.data
        }
    } catch (error) {
        console.log(error)
    }

} 
export { LOGIN, getCountry, getShipements, getShipement, creatShipementInServer, deleteShipementInServer, updateShipmentInServer }




